import React from 'react';
import Table from 'components/table';
import config from 'config';


export const UserReactions = ({ user }) => (
  <Table black>
    <thead>
      <tr>
        <th>Установа</th>
        <th>Коментар</th>
        <th>Час відповіді</th>
        <th>Документ</th>
        <th>Стан</th>
      </tr>
    </thead>
    <tbody>
      {user.map((item, i) => (
        <tr key={i}>
          <td><span>Установа:</span>{item.getIn(['responsible_staff_data', 'institution_data', 'full_title'])} ({item.getIn(['responsible_staff_data', 'user_data', 'last_name'])} {item.getIn(['responsible_staff_data', 'user_data', 'first_name'])})</td>
          <td><span>Коментар:</span>{item.get('comment') ? item.get('comment') : "Коментар відсутній"}</td>
          <td><span>Час відповіді:</span>{item.get('status') ? new Date(item.get('status')).toLocaleString('uk-UA', config.options) : "Не вказано"}</td>
          {item.get('file') !==null ? (
            <td><span>Документ:</span><a href={item.get('file')} target="_blank"><i class="fa fa-file-text-o" aria-hidden="true"></i></a></td>
          ):(
            <td><span>Документ:</span>Документ відсутній</td>
          )}
          <td><span>Стан:</span>{item.get('status') ? <i style={{color: "#edbd2f", fontSize: "24px"}} className="fa fa-check-circle" /> : <i style={{color: "#dd4b39", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i> }</td>
        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/admin/mailing/detail/user-reactions.js